<h1 class="u-srOnly">{{ 'Amplify.hype.wire.headline' | localize }}</h1>
<agpr-master-layout [id]="'amplify'" [layout]="layout">
    <!-- Hidden as part of NEP-31806. Unhide when Newswire builder is refactored -->
    <ng-template *ngIf="false" let-item agprTemplate="navigation">
        <agpr-left-sidebar [hideManageListDialog]="hideManageListDialog"></agpr-left-sidebar>
    </ng-template>
</agpr-master-layout>
